import initReactApp from 'dpl/util/initReactApp';
import BreedOverviewMobileNavigation from 'dpl/breed_overview/components/BreedOverviewMobileNavigation';
import BreedOverviewNavigation from 'dpl/breed_overview/components/BreedOverviewNavigation';
import GetToKnowAuthorSection from 'dpl/breed_overview/components/GetToKnowAuthorSection';
import Layout from 'dpl/breed_overview/components/Layout';

initReactApp({
  BreedOverviewMobileNavigation,
  BreedOverviewNavigation,
  Layout,
  GetToKnowAuthorSection
});
